/** @jsx jsx */
import { jsx } from '@balance-web/core';
import { useRouter } from 'next/router';

import { NotFoundPage } from '../components/app/NotFoundPage';

function NotFoundRoute() {
  const router = useRouter();
  return (
    <NotFoundPage onGotoHomepageClick={() => router.push({ pathname: '/' })} />
  );
}

export default NotFoundRoute;
